import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface StateBasedState {
  isd_data: string | number | Array;
  nisd_data: string | number | Array;
  fline_data: string | number | Array;
  isd_code: string | number | Array;
  nisd_code: string | number | Array;
  fline_code: string | number | Array;
  medium_code: string | number | Array;
  medium_data: string | number | Array;
}
const initialState: StateBasedState = {
  isd_data: [],
  nisd_data: [],
  fline_data: [],
  isd_code: [],
  nisd_code: [],
  fline_code: [],
  medium_code: [],
  medium_data: [],
};

const stateSlice = createSlice({
  name: "stateDetails",
  initialState,
  reducers: {
    setSelectedIsd: (state, action: PayloadAction<string | number>) => {
      state.isd_data = action.payload;
    },
    setSelectedNisd: (state, action: PayloadAction<string | number>) => {
      state.nisd_data = action.payload;
    },
    setSelectedFline: (state, action: PayloadAction<string | number>) => {
      state.fline_data = action.payload;
    },

    setSelectedIsdCode: (state, action: PayloadAction<string | number>) => {
      state.isd_code = action.payload;
    },
    setSelectedNisdCode: (state, action: PayloadAction<string | number>) => {
      state.nisd_code = action.payload;
    },
    setSelectedFlineCode: (state, action: PayloadAction<string | number>) => {
      state.fline_code = action.payload;
    },

    setSelectedMediumCode: (state, action: PayloadAction<string | number>) => {
      state.medium_code = action.payload;
    },

    setSelectedMediumData: (state, action: PayloadAction<string | number>) => {
      state.medium_data = action.payload;
    },
  },
});

export const {
  setSelectedIsd,
  setSelectedNisd,
  setSelectedFline,
  setSelectedIsdCode,
  setSelectedNisdCode,
  setSelectedFlineCode,
  setSelectedMediumCode,
  setSelectedMediumData,
} = stateSlice.actions;
export default stateSlice.reducer;
